import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericService } from 'app/_services/generic.service';
import { WorkActivityOptionsModel } from './work-activity-option.model';

@Injectable({
  providedIn: 'root'
})
export class WorkActivityOptionsService extends GenericService<WorkActivityOptionsModel> {
  constructor(private http: HttpClient) {
    super(http, '/WorkActivityOptions/')
}
}